module.exports = __webpack_public_path__ + "static/media/gooey-removebg-preview (1).4ec9b6d9.png";